﻿import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { DataTableModule } from 'primeng/components/datatable/datatable';
import { PaginatorModule } from 'primeng/components/paginator/paginator';
import { ButtonModule } from 'primeng/components/button/button';
import { AutoCompleteModule } from 'primeng/components/autocomplete/autocomplete';
import { ToolbarModule } from 'primeng/components/toolbar/toolbar';
import { SplitButtonModule } from 'primeng/components/splitbutton/splitbutton';
import { DropdownModule } from 'primeng/components/dropdown/dropdown';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { CalendarModule } from 'primeng/components/calendar/calendar';
import { SharedModule } from 'primeng/components/common/shared';
import { ToggleButtonModule } from 'primeng/components/togglebutton/togglebutton';
import { ScheduleModule } from 'primeng/components/schedule/schedule';
import { TooltipModule } from 'primeng/components/tooltip/tooltip';
import { GrowlModule } from 'primeng/components/growl/growl';
import { FileUploadModule } from 'primeng/components/fileupload/fileupload';
import { ConfirmDialogModule } from 'primeng/components/confirmdialog/confirmdialog';
import { ChipsModule } from 'primeng/components/chips/chips';
import { TreeModule } from 'primeng/components/tree/tree';
import { GalleriaModule } from 'primeng/components/galleria/galleria';
import { CarouselModule } from 'primeng/components/carousel/carousel';
import { CaptchaModule } from 'primeng/components/captcha/captcha';
import { InputSwitchModule } from 'primeng/components/inputswitch/inputswitch';

@NgModule({
    imports: [FormsModule,
        ReactiveFormsModule,
        CommonModule,
        DataTableModule,
        SharedModule,
        PaginatorModule,
        ButtonModule,
        AutoCompleteModule,
        ToolbarModule,
        SplitButtonModule,
        DropdownModule,
        DialogModule,
        CalendarModule,
        ToggleButtonModule,
        ScheduleModule,
        TooltipModule,
        GrowlModule,
        FileUploadModule,
        ConfirmDialogModule,
        ChipsModule,
        TreeModule,
        GalleriaModule,
        CarouselModule,
        CaptchaModule,
        InputSwitchModule],
    declarations: [/*Calendar, DataTable, Column, Button, Header, TrimmedInput, AutoComplete, Schedule*/],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        DataTableModule,
        SharedModule,
        PaginatorModule,
        ButtonModule,
        AutoCompleteModule,
        ToolbarModule,
        SplitButtonModule,
        DropdownModule,
        DialogModule,
        CalendarModule,
        ToggleButtonModule,
        ScheduleModule,
        TooltipModule,
        GrowlModule,
        FileUploadModule,
        ConfirmDialogModule,
        ChipsModule,
        TreeModule,
        GalleriaModule,
        CarouselModule,
        CaptchaModule,
        InputSwitchModule]
})
export class PrimeSharedModule {

}
